import React, {
  useEffect,
} from 'react';
import {
  useParams,
  useNavigate,
} from 'react-router-dom';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import MobileDetect from 'mobile-detect';

import {
  coreActions,
} from '@gymcloud/core';

import {
  getUiState,
} from 'web-selectors';

import {
  Spinner,
} from 'web-components';

import * as S from '../styled';

const md = new MobileDetect(window.navigator.userAgent);

const mapState = state => ({
  namespace: getUiState('namespace')(state),
});

const LoginWithToken = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const { namespace } = useSelector(mapState);

  useEffect(() => {
    if (namespace.symbol === 'ideafit' && md.mobile()) {
      navigate('/use_app');
      return;
    }

    if (!params.token) {
      navigate('/login');
      return;
    }

    dispatch(
      coreActions.loginWithToken(params.token),
    );
  }, [namespace.symbol, params.token, md]);

  return (
    <S.PageWrap>
      <Spinner />
    </S.PageWrap>
  );
};

export default LoginWithToken;
